import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
} from "@mui/material";
import axios from "axios";
import { useUser } from "../provider/AuthProvider";
import { toast } from "react-toastify";

const AssignServiceDialog = ({
  open,
  onClose,
  provider,
  availableServices,
  onAssigned,
}) => {
  const [selectedService, setSelectedService] = useState("");
  const [customService, setCustomService] = useState({
    name: "",
    description: "",
    logo_url: "",
  });
  const [loading, setLoading] = useState(false);
  const isReassign = provider?.compoundserviceType !== "null";

  const isOtherSelected = selectedService === "other";
  const { user } = useUser();

  useEffect(() => {
    if (open && provider && provider?.compound) {
      const matched = availableServices.find(
        (s) => s.name === provider?.compoundserviceType
      );
      if (matched) {
        setSelectedService(matched.id);
      } else {
        setSelectedService("");
        setCustomService({
          name: provider?.compoundserviceType,
          description: "", // Optional
          logo_url: provider?.compoundserviceType_logo || "",
        });
      }
    } else if (open) {
      setSelectedService("");
      setCustomService({ name: "", description: "", logo_url: "" });
    }
  }, [open, provider, availableServices]);

  const handleConfirm = async () => {
    try {
      setLoading(true);

      const payload = {
        user_id: user.id,
        provider_id: provider.id,
        isOtherSelected,
        service_type_id: isOtherSelected ? null : selectedService,
        custom_service: isOtherSelected ? customService : null,
      };
      console.log(payload);
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/cmt/assignService`,
        payload
      );

      onAssigned();
      onClose();
    } catch (error) {
      console.error("Error assigning service:", error);
      toast.error(
        error.response?.data?.error ||
          "Failed to assign service. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Assign Service</DialogTitle>

      <DialogContent>
        <Box mt={1}>
          <Typography variant="subtitle2">
            Registration Service Type:
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {provider?.registrationsServiceType || "N/A"}
          </Typography>
        </Box>
        {isReassign && (
          <Box mt={2}>
            <Typography variant="subtitle2">
              Currently Assigned Service:
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {provider?.compoundserviceType}
            </Typography>
          </Box>
        )}

        <Box mt={3}>
          <FormControl fullWidth>
            <InputLabel>Available Service Types</InputLabel>
            <Select
              value={selectedService}
              onChange={(e) => setSelectedService(e.target.value)}
              label="Available Service Types"
            >
              {availableServices.map((service) => (
                <MenuItem key={service.id} value={service.id}>
                  {service.name}
                </MenuItem>
              ))}
              <MenuItem value="other">Other</MenuItem>
            </Select>
          </FormControl>
        </Box>

        {isOtherSelected && (
          <Box mt={3}>
            <TextField
              label="Service Name"
              fullWidth
              margin="normal"
              value={customService.name}
              onChange={(e) =>
                setCustomService({ ...customService, name: e.target.value })
              }
            />
            <TextField
              label="Service Description"
              fullWidth
              multiline
              rows={3}
              margin="normal"
              value={customService.description}
              onChange={(e) =>
                setCustomService({
                  ...customService,
                  description: e.target.value,
                })
              }
            />
            <TextField
              label="Logo URL"
              fullWidth
              margin="normal"
              value={customService.logo_url}
              onChange={(e) =>
                setCustomService({ ...customService, logo_url: e.target.value })
              }
            />
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleConfirm} variant="contained" disabled={loading}>
          {loading ? "Confirm..." : "Confirm"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssignServiceDialog;
